export type DeviceState = 'Pending' | 'Active' | 'Disabled' | 'Deleted' | 'Lost' | 'Offline';

export const DeviceStateMap: Record<number, DeviceState> = {
  0: 'Pending',
  1: 'Active',
  2: 'Disabled',
  3: 'Deleted',
  4: 'Lost',
  5: 'Offline',
};

export const DeviceStateLabels: Record<DeviceState, string> = {
  Pending: 'Pendiente',
  Active: 'Activo',
  Disabled: 'Desactivado',
  Deleted: 'Eliminado',
  Lost: 'Perdido',
  Offline: 'Sin reportar',
};

export const DeviceStateColors: Record<DeviceState, string> = {
  Pending: 'default',
  Active: 'success',
  Disabled: 'warning',
  Deleted: 'error',
  Lost: 'error',
  Offline: 'warning',
};

export interface DeviceDto {
  id: number;
  enterpriseId: number;
  enterpriseName: string;
  profileId?: number | null;
  profileName?: string | null;
  googleDeviceId?: string | null;
  serialNumber?: string | null;
  imeiNumber?: string | null;
  model?: string | null;
  brand?: string | null;
  androidVersion?: string | null;
  androidApiLevel?: number | null;
  assignedToName?: string | null;
  assignedToEmail?: string | null;
  assignedToPhone?: string | null;
  expectedPin: string;
  currentState: number;
  enrolledAt?: string | null;
  lastSyncAt?: string | null;
  isActive: boolean;
  createdAt: string;
  pendingCommandsCount: number;
}

export interface DeviceAppReportDto {
  packageName: string;
  versionName?: string | null;
  versionCode?: number | null;
  displayName?: string | null;
  iconUrl?: string | null;
  installationSource?: string | null;
  state?: string | null;
  isInProfileCatalog: boolean;
}

export interface DeviceLocationDto {
  latitude: number;
  longitude: number;
  reportedAt: string;
  accuracyMeters?: number | null;
}

export interface DeviceHardwareInfoDto {
  totalRamBytes?: number | null;
  totalInternalStorageBytes?: number | null;
  batteryLevelPercent?: number | null;
  wifiMacAddress?: string | null;
  cellularNetworkOperator?: string | null;
  phoneNumber?: string | null;
  androidBuildNumber?: string | null;
  securityPatchLevel?: string | null;
  bootloader?: string | null;
  kernelVersion?: string | null;
  lastBootTime?: string | null;
}

export interface DeviceDetailDto extends DeviceDto {
  installedApps: DeviceAppReportDto[];
  lastKnownLocation?: DeviceLocationDto | null;
  hardwareInfo?: DeviceHardwareInfoDto | null;
  isEnrolledInGoogle: boolean;
  googleResourceName?: string | null;
}

export interface DeviceAuditEntryDto {
  id: number;
  eventType: string;
  userName?: string | null;
  createdAt: string;
  oldValues?: string | null;
  newValues?: string | null;
  additionalInfo?: string | null;
  ipAddress?: string | null;
}

export interface CreateDeviceRequest {
  enterpriseId: number;
  profileId?: number;
  serialNumber?: string;
  imeiNumber?: string;
  model?: string;
  brand?: string;
  assignedToName?: string;
  assignedToEmail?: string;
  assignedToPhone?: string;
  expectedPin?: string;
}

export interface UpdateDeviceRequest {
  profileId?: number;
  assignedToName?: string;
  assignedToEmail?: string;
  assignedToPhone?: string;
  expectedPin?: string;
}

export interface DeviceListRequest {
  page?: number;
  pageSize?: number;
  search?: string;
  sortBy?: string;
  sortDescending?: boolean;
  includeInactive?: boolean;
  enterpriseId?: number;
  profileId?: number;
  state?: number;
}

export interface QuickCommandRequest {
  commandType: number;
  parametersJson?: string;
}
